import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { Row, Layout, Form, Button, Spin, notification, Space } from 'antd';
import TramittaLogo from '../../images/tramitta-logo.png';
import LegalChileLogo from '../../images/legalchile.svg';
import SuccessEdit from '../../components/edit/Success';
import Fail from '../../components/edit/Fail';
import decode from '../../helpers/urlParamDecode';
import { STATUS } from '../../config/constants/states';
import { GET_CONTRACT_DATA_FORM, VERIFY_TOKEN, CONTRACT_FORM_DATA, UPDATE_CONTRACT_FORM_DATA, REJECT_OBJECTION, GET_PREVIEW_PDF, GET_CONTRACT_PDF } from '../../state/lease_contract/types';
import { RESOURCE } from '../../config/constants/alerts';
import { ROLES, STATES } from '../../config/constants/contractStates';
import alertError from '../../components/alerts/AlertErrorForm';
import ModalRejectObjection from '../../components/modals/ModalRejectObjection';
import ObjectionMessage from '../../components/ObjectionMsg';
import { OBJECTION_MSG_KEY } from '../../config/constants/forms';
import { CREATE_CONTRACT_STATUS } from '../../config/constants/states';
import Alert from '../../components/alerts/Alerts';
import PreviewModal from '../../components/formPreview/PreviewModal';
import PropTypes from 'prop-types';
import ShowPdf from '../../components/pdf/ShowPdf';
import CreateContractHeader from '../../components/create_contract/header/index';
import SignersStep from '../../components/contract/SignersStep';
import PropertyStep from '../../components/contract/PropertyStep';
import AccountStep from '../../components/contract/AccountStep';
import Schema from '../../classes/index';

const { Header, Content } = Layout;

const EditContract = ({
  getContractDataForm,
  verifyToken,
  contractFormData,
  updateForm,
  sendContract,
  tokenStatus,
  isCreated,
  sendRejectObjection,
  objIsRejected,
  objRejectedFail,
  images,
  getPreview,
  contractPdf,
  getPDF,
  contract,
  editSpinner
}) => {

  const [form] = Form.useForm();
  const { params } = useParams();
  const [current, setCurrent] = useState(0);
  const [tokenParams, setTokenParams] = useState('');
  const [valid, setIfValid] = useState(true);
  const [loaderSpinning, setLoaderSpinning] = useState(true);
  const [rejectObjectVisible, setRejectObjectVisible] = useState(false);
  const [modalSpinning, setModalSpinning] = useState(false);
  const [activeStep, setActiveStep] = useState(0);

  useEffect(() => {
    verifyToken(params);
    const data = decode(params);
    setTokenParams(data);
    if (data[0]) {
      getContractDataForm(data[0]);
      if (contractPdf === '') { getPDF(data[0]); }
    }
  }, []);

  useEffect(() => {
    if (contractFormData.editForm) form.setFieldsValue(contractFormData);
  }, [contractFormData]);

  useEffect(() => {
    if (tokenParams === STATUS.ERROR) {
      setIfValid(false);
      setLoaderSpinning(false);
    }
    if (tokenStatus !== '' && tokenParams[0]) {
      if (tokenStatus === STATES.OBJECTED && tokenParams[1] === ROLES.OWNER) {
        setLoaderSpinning(false);
      } else {
        setIfValid(false);
        setLoaderSpinning(false);
      }
    }
  }, [tokenParams, tokenStatus]);

  useEffect(() => {
    if (isCreated === CREATE_CONTRACT_STATUS.SUCCESS) {
      setLoaderSpinning(false);
      notification.close(OBJECTION_MSG_KEY);
      setCurrent(2);
    }
  }, [isCreated]);

  useEffect(() => {
    if (contract.objection) {
      ObjectionMessage(OBJECTION_MSG_KEY, contract.objection);
    }
  }, [contract]);

  useEffect(() => {
    if (objIsRejected) {
      notification.close(OBJECTION_MSG_KEY);
      setModalSpinning(false);
      setRejectObjectVisible(false);
      setCurrent(2);
    }
  }, [objIsRejected]);

  useEffect(() => {
    if (objRejectedFail) {
      setModalSpinning(false);
    }
  }, [objRejectedFail]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    if (current === 0 && contractFormData.editForm) getPreview(Schema.rentContract.preview(contractFormData));
  }, [current]);

  const formContent = (data) => {
    if (activeStep < 3) {
      updateForm({
        ...contractFormData,
        ...data,
        ...images,
      });
    }
    if (activeStep < steps.length - 1) {
      handleNext();
    } else {
      setCurrent(0);
    }
  };

  const submitContract = async () => {
    setModalSpinning(true);
    sendContract(tokenParams[0], await Schema.rentContract.edit(contractFormData), params);
  };

  const rejectObjection = () => {
    setModalSpinning(true);
    sendRejectObjection(tokenParams[0], params);
  };

  const handleNext = () => {
    setActiveStep(activeStep + 1);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  const steps = [
    {
      title: 'Información firmantes',
      content: <SignersStep form={form} />,
    },
    {
      title: 'Inmueble y condiciones',
      content: <PropertyStep />,
    },
    {
      title: 'Contrato y cuenta',
      content: <AccountStep form={form} />,
    }
  ];

  return (
    <>
      {loaderSpinning
        ? <Spin className="spin-centered" tip="Cargando..."></Spin>
        : <>
          {valid ?
            <>
              <Header className="header-container">
                <Row className="header-logos mb-0">
                  <img src={LegalChileLogo} alt="" className="legal-logo" />
                  <img src={TramittaLogo} alt="" className="tramitta-logo" />
                </Row>
              </Header>
              <Content className="ant-layout-content-edit">
                <Alert />
                {current === 0 &&
                  <React.Fragment>
                    <Spin spinning={editSpinner} tip="Procesando...">
                      <div style={{ width: '60%', margin: 'auto', marginBottom: '100px' }}>
                        <ShowPdf pdf={contractPdf} />
                      </div>
                      <div className="buttons-container buttons-triple justify-content-end bg-white">
                        <Button size="large" type="default" className="mr-2" onClick={() => setRejectObjectVisible(true)} >
                          Rechazar objeción
                        </Button>
                        <Button size="large" type="default" className="mr-2" onClick={() => setCurrent(1)}>
                          Editar
                        </Button>
                        <Button size="large" type="primary" onClick={submitContract} >
                          Enviar
                        </Button>
                      </div>
                    </Spin>
                  </React.Fragment>
                }
                {current === 1 &&
                  <>
                    <CreateContractHeader steps={steps} activeStep={activeStep} />
                    <Form
                      form={form}
                      layout="vertical"
                      onFinish={formContent}
                      onFinishFailed={alertError}
                      autoComplete="on"
                      scrollToFirstError
                    >
                      <Content className="ant-layout-content-custom">
                        <div className="steps-content">{steps[activeStep].content}</div>
                      </Content>
                      <div className="buttons-container justify-content-center">
                        <Space>
                          <PreviewModal />
                          <Button size="large"
                            onClick={() => {
                              activeStep > 0 ? handleBack() : setCurrent(0);
                            }}
                          >
                            Volver
                          </Button>
                          <Button type="primary" htmlType="submit" size="large">
                            Continuar
                          </Button>
                        </Space>
                      </div>
                    </Form>
                  </>
                }
                {current === 2 && <SuccessEdit />}
              </Content>
              <ModalRejectObjection
                visible={rejectObjectVisible}
                onCancel={() => setRejectObjectVisible(false)}
                onCreate={() => rejectObjection()}
                spinning={modalSpinning}
              />
            </>
            : <Fail />
          }
        </>
      }
    </>
  );
};

EditContract.propTypes = {
  getContractDataForm: PropTypes.func.isRequired,
  verifyToken: PropTypes.func.isRequired,
  contractFormData: PropTypes.object.isRequired,
  updateForm: PropTypes.func.isRequired,
  sendContract: PropTypes.func.isRequired,
  tokenStatus: PropTypes.string.isRequired,
  isCreated: PropTypes.string.isRequired,
  sendRejectObjection: PropTypes.func.isRequired,
  objIsRejected: PropTypes.bool.isRequired,
  objRejectedFail: PropTypes.bool.isRequired,
  images: PropTypes.object.isRequired,
  getPreview: PropTypes.func.isRequired,
  contractPdf: PropTypes.string.isRequired,
  getPDF: PropTypes.func.isRequired,
  contract: PropTypes.object.isRequired,
  editSpinner: PropTypes.bool.isRequired,
};

const data = (state) => ({
  contractFormData: state.contract.contractFormData,
  tokenStatus: state.contract.tokenStatus,
  isCreated: state.contract.isCreated,
  objIsRejected: state.contract.objIsRejected,
  objRejectedFail: state.contract.objRejectedFail,
  images: state.contract.images,
  contractPdf: state.contract.contractPdf,
  contract: state.contract.contract,
  editSpinner: state.contract.editSpinner
});

const action = (dispatch) => ({
  getPDF: (id) => dispatch({ type: GET_CONTRACT_PDF, payload: { id, resource: RESOURCE.GET_CONTRACT_PDF } }),
  updateForm: (data) => dispatch({ type: CONTRACT_FORM_DATA, payload: { ...data } }),
  verifyToken: (token) => dispatch({ type: VERIFY_TOKEN, payload: token }),
  getContractDataForm: (id) => dispatch({ type: GET_CONTRACT_DATA_FORM, payload: { id, resource: RESOURCE.GET_CONTRACT_DATA_FORM } }),
  sendContract: (id, doc, token) => dispatch({ type: UPDATE_CONTRACT_FORM_DATA, payload: { id, doc, token, resource: RESOURCE.UPDATE_CONTRACT_FORM_DATA } }),
  sendRejectObjection: (id, token) => dispatch({ type: REJECT_OBJECTION, payload: { id, token, resource: RESOURCE.REJECT_OBJECTION } }),
  getPreview: payload => dispatch({ type: GET_PREVIEW_PDF, payload: { payload, resource: RESOURCE.GET_PREVIEW_PDF } }),
});

export default connect(data, action)(EditContract);